module.exports = __webpack_public_path__ + "img/社会综治-物联网智慧平安小区管理平台V2.0.736bb8e2.jpg";